import { string } from '@iwentsourcing/core/typing/string.js';
import { TypeOfEvent } from '@iwentsourcing/core/typing/type-of.js';
import { EventAuth } from '@iwentsourcing/core/event-store/event-auth.js';
import { declareEvent } from '@iwentsourcing/core/storage/declare-event.js';

export const InviteUserEvent = declareEvent('invite-user', {
  id: string(),

  groupName: string(),
  groupId: string(),

  name: string(),
  email: string(),

  user: EventAuth,
});

export type InviteUserEvent = TypeOfEvent<typeof InviteUserEvent>;
